module.exports = __webpack_public_path__ + "static/media/ICBT Clip On Cutter.4a7b2561.jpg";